/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'underscore';

class ErrorModule extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            errors: [],
            options: props.options
        };

    }

    static getDerivedStateFromProps(props, state) {
        let nextState = {},
            nextErrors = [],
            i = 0,
            j = 0;

        if (props.app && props.app.errors !== undefined) {
            for (i = 0; i < props.app.errors.api.length; ++i) {
                for (j = 0; j < props.keys.length; ++j) {
                    if (props.app.errors.api[i].type.match(props.keys[j])) {
                        nextErrors.push(props.app.errors.api[i].error);
                    }
                }
            }
            for (i = 0; i < props.app.errors.local.length; ++i) {
                for (j = 0; j < props.keys.length; ++j) {
                    if (props.app.errors.local[i].type.match(props.keys[j])) {
                        nextErrors.push(props.app.errors.local[i].error);
                    }
                }
            }

            if (!_.isEqual(nextErrors, state.errors)) {
                nextState.errors = nextErrors;
            }

            // make sure the options gets copied in
            if (props.options) {
                nextState.options = props.options;
            }
        }

        return Object.keys(nextState).length ? nextState : null;

    }

    render() {
        return this.props.render(this.state);
    }

}

ErrorModule.displayName = "ErrorModule";

export default ErrorModule;
